import { Route, Redirect } from 'wouter';
import { useAuthContext } from '@/context/authentication/auth-context';
import { Loader2 } from 'lucide-react';
import { OnboardingGuard } from './onboarding-guard';
import { GuardProps } from './guard.types';
import { OnboardingStep } from '../onboarding';

export function AuthGuard({ path, component }: Omit<GuardProps, 'step'>) {
  const { isLoading, isAuthenticated, person } = useAuthContext();
  const step = Number(person?.user?.onboarding_steps);

  if (isLoading) {
    return (
      <Route path={path}>
        <div className="flex items-center justify-center min-h-screen">
          <Loader2 className="h-8 w-8 animate-spin" />
        </div>
      </Route>
    );
  }

  if (!isAuthenticated) {
    return (
      <Route path={path}>
        <Redirect to="/login" />
      </Route>
    );
  }

  if (step === OnboardingStep.FINISHED) {
    return <Route path={path} component={component} />;
  }

  return <OnboardingGuard
    path={path}
    component={component}
    step={step}
  />;
}
